((window) => {
    class HandelSearch {
        #searchWrapper = null;
        constructor(config, setSearchKey) {
            this.setSearchKeyCallBack = setSearchKey
            this.searchValue = {};
            this.debounceTimer = null;
            this.initWraper()
            if (config.searchItems instanceof Array && config.searchItems.length > 0) {
                this.initContent(config);
            }
        }
        resetSearchValue() {
            this.searchValue = {}
        }
        resetSearchValue(key, value) {
            this.searchValue[key] = value;
        }
        initWraper() {
            this.#searchWrapper = document.createElement('div');
            this.#searchWrapper.className = "search-wraper";
        }
        initContent(config) {
            if (config.searchItems instanceof Array && config.searchItems.length > 0) {
                const isErrorSearchKeys = config.searchItems.filter(item => !config.tableKeys.includes(typeof item == "object" ? item.key : item))
                    .map(item => typeof item == "object" ? item.key : item);

                if (isErrorSearchKeys.length > 0) {
                    console.warn(`These keys used for searching are not present in the data and have been automatically deleted.\n
                      ${isErrorSearchKeys}`)
                }
                config.searchItems = config.searchItems.filter(item => !isErrorSearchKeys.includes(typeof item == "object" ? item.key : item))
            }
            const searchFragment = document.createDocumentFragment();
            config.searchItems.forEach(item => {
                const isObjtype = typeof item == "object";
                let filename = isObjtype ? item.key : item;
                if (config.hidden) {
                    if (!isObjtype && config.hidden.includes(item) || isObjtype && config.hidden.includes(item.key)) {
                        console.warn(`The  ${filename} is hidden, so the search box cannot be generated`)
                        return
                    }
                    if (!isObjtype && !config.tableKeys.includes(item) || isObjtype && !config.tableKeys.includes(item.key)) {
                        console.warn(`The ${filename} field does not exist.so the search box cannot be generated`)
                        return
                    }
                }
                const inputEl = document.createElement('input')
                inputEl.placeholder = isObjtype ? item.lable : item;
                inputEl.setAttribute("data-search", isObjtype ? item.key : item)
                inputEl.addEventListener('keyup', (e) => {
                    clearTimeout(this.debounceTimer);
                    this.debounceTimer = setTimeout(() => {
                        this.setSearchKeyCallBack(e);
                    }, config.debounceDelay || 500);
                });
                searchFragment.appendChild(inputEl);
            })
            if (config.searchCustomPosition) {
                config.searchCustomPosition(searchFragment)
            } else {
                this.#searchWrapper.appendChild(searchFragment)
            }
        }
        get searchWrapper() {
            return this.#searchWrapper;
        }
    }
    class HandleNodeManage {
        #dataListNodeMap = new Map();
        #tableWraper = null;
        #searchNodes = null;
        constructor(dataList, config) {
            this.config = { ...config };
            this.initTableWraper()
            this.init(dataList)
        }
        initTableWraper() {
            this.#tableWraper = document.createElement('table')
            this.#tableWraper.className = 'table auto-table'
        }
        init(dataList) {
            this.config.tableKeys = Object.keys(dataList[0])
            this.initTableTitle()
            this.initTableContent(dataList)
        }
        createTableElement(type, content, key, row, tableRowindex) {
            const el = document.createElement(type)
            if (key && this.config.processing instanceof Array) {
                const processingItem = this.config.processing.find(item => item.key.toLowerCase() == key.toLowerCase())
                if (processingItem) {
                    content = processingItem.callBack(content, row, el, tableRowindex)
                }
            }
            el.innerHTML = content;
            return el
        }
        initTableTitle() {
            const tr = document.createElement('tr');
            tr.className = "table-header"
            this.renderAcitonsTitle('left', tr)
            for (let title of this.config.tableKeys) {
                if (this.config.hidden instanceof Array && this.config.hidden.length > 0 && this.config.hidden.includes(title)) {
                    continue;
                }

                if (this.config.renameTitle && typeof this.config.renameTitle == 'function') {
                    title = this.config.renameTitle(title)
                }
                const th = this.createTableElement('th', title)
                tr.appendChild(th);
            }
            this.renderAcitonsTitle('right', tr)
            this.#tableWraper.appendChild(tr);
        }
        checkAlgin(algin) {
            if (!['left', 'right'].includes(algin.toLowerCase())) {
                throw new Error(`The value of rowBtn.align can only be left or right.not ${algin}`)
            }
        }
        renderAcitonsTitle(algin, parent, value) {
            this.checkAlgin(algin);
            const isArr = this.config.rowBtn instanceof Array;
            if (algin.toLowerCase() == algin) {
                if (!isArr && this.config.rowBtn && this.config.rowBtn.align.toLowerCase() == algin) {
                    const el = this.createTableElement('th', this.config.rowBtn.rowName)
                    parent.appendChild(el)
                }
            }
        }
        renderActions(algin, parent, value) {
            this.checkAlgin(algin)
            const isArr = this.config.rowBtn instanceof Array;
            if (algin.toLowerCase() == algin) {
                if (!isArr && this.config.rowBtn && this.config.rowBtn.align.toLowerCase() == algin) {
                    const td = document.createElement('td')
                    const el = this.createTableElement(this.config.rowBtn.type, this.config.rowBtn.btnText)
                    el.className = "btn bg-gold"
                    if (this.config.rowBtn.rendering) {
                        this.config.rowBtn.rendering.call(el, value)
                    }
                    td.appendChild(el)
                    if (this.config.rowBtn.event) {
                        el.addEventListener('click', (e) => {
                            e.preventDefault()
                            this.config.rowBtn.event.call(el, value)
                        })
                    }
                    parent.appendChild(td)
                }
            }
        }
        initTableContent(dataList) {
            dataList.forEach((item, index) => {
                const tr = document.createElement('tr');
                tr.className = index % 2 == 0 ? 'tr-even' : 'tr-odd';
                this.renderActions('left', tr, item)
                for (const [key, value] of Object.entries(item)) {
                    if (this.config.hidden instanceof Array && this.config.hidden.length > 0 && this.config.hidden.includes(key)) {
                        continue;
                    }
                    const td = this.createTableElement('td', value, key, item, index)
                    tr.appendChild(td)
                }
                this.renderActions('right', tr, item)
                this.tableWraper.appendChild(tr)
                this.#dataListNodeMap.set(tr, item)
            })
        }
        get tableWraper() {
            return this.#tableWraper
        }
        filter(filterObj) {
            let i = 0;
            this.#dataListNodeMap.forEach((value, node) => {
                let flag = Object.entries(filterObj).every(([key, searchValue]) => {
                    if (!searchValue) {
                        return true
                    }
                    if (!value[key] || !value[key].toString().toLowerCase().includes(searchValue.toString().toLowerCase())) {
                        return false;
                    }
                    return true
                })
                node.style.display = flag ? "" : "none";
                if (flag) {
                    node.className = i % 2 == 0 ? "tr-even" : "tr-odd";
                    i++;
                }
            })
        }
    }
    class HandleCreateTable {
        #encodedToken = "";
        #container = null;
        #loadingNode = null;
        #searchNodes = null;
        #HandleNodeManage = null;
        #searchObjValue = {};
        constructor(config) {
            if (config.rowBtn) {
                config.rowBtn.align = config.rowBtn.align ? config.rowBtn.align : 'left';
            }
            this.config = config;
            this.verification(config);
        }
        verification() {
            if (this.config.searchItems && !this.config.searchItems instanceof Array) {
                throw new Error('searchItems must be an array');
            }
            const ct = document.querySelector(this.config.container)
            if (!ct) {
                throw new Error('specify a container to load the content into');
            }
            this.#container = ct;
        }
        async httpRequest(url, option = {}) {
            const mergedOptions = { ...option, method: option.method || "get" };
            return await fetch(url, {
                ...mergedOptions,
            }).then(v => v.json()).then(res => {
                return res;
            }).catch(e => {
                throw new Error(e.message)
            })
        }
        async httpGet(url, callBack, option) {
            let res = await this.httpRequest(url, option);
            if (callBack) {
                const result = callBack(res);
                res = result instanceof Promise ? await result : result;
            }
            if (res && res.length) {
                this.config.tableKeys = Object.keys(res[0]);
                this.#searchNodes = new HandelSearch(this.config, this.setSearchKey.bind(this))
                this.#HandleNodeManage = new HandleNodeManage(res, this.config);
                this.render()
            } else {
                if (this.config.customRende) {
                    let res = this.config.customRende();
                    this.customRendeDom(res)
                }
            }
        }
        async simulateReturnedData(data, callBack) {
            let res = data;
            if (callBack) {
                const result = callBack(data);
                res = result instanceof Promise ? await result : result;
            }
            if (res && res.length) {
                this.config.tableKeys = Object.keys(res[0]);
                this.#searchNodes = new HandelSearch(this.config, this.setSearchKey.bind(this))
                this.#HandleNodeManage = new HandleNodeManage(res, this.config);
                this.render()
            }
        }

        initData(data) {
            if (data && data.length) {
                this.config.tableKeys = Object.keys(data[0]);
                this.#searchNodes = new HandelSearch(this.config, this.setSearchKey.bind(this))
                this.#HandleNodeManage = new HandleNodeManage(data, this.config);
                this.render()
            }
        }
        setSearchKey(e) {
            const key = e.target.dataset.search;
            const value = e.target.value.trim();
            if (this.#searchObjValue[key] == value) {
                return;
            }
            this.#searchObjValue[key] = value;
            this.#HandleNodeManage.filter(this.#searchObjValue)
        }
        customRendeDom(res) {
            this.#container.innerHTML = res;
        }
        render() {
            const fragment = document.createDocumentFragment();
            if(!this.config.searchCustomPosition){
                fragment.appendChild(this.#searchNodes.searchWrapper)
            }
            fragment.appendChild(this.#HandleNodeManage.tableWraper)
            if (this.config.customColumn) {
                this.config.customColumn(this.#HandleNodeManage.tableWraper)
            }
            this.#container.appendChild(fragment)
            if (this.config.complete) {
                this.config.complete();
            }
        }
    }
    window.HandleCreateTable = HandleCreateTable;
})(window)